import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { Chip } from '@mui/material'

export const StyledChip = styled(Chip, {
  shouldForwardProp: labelColour => isPropValid(labelColour),
})<CmsProps>`
  width: fit-content;
  background-color: ${({ backgroundColour }) => backgroundColour ?? '#FFF'};
  color: ${({ labelColour }) => labelColour ?? '#000'};
  padding: 1.3rem;
  font-size: 0.875rem;
  border-radius: 70px;
  z-index: 2;
`
